import Social from "./Assets/Projects/social.png";
import Ecommerce from "./Assets/Projects/ecommerce.png";
import Resume from "./Assets/Projects/resumebuilder.png";
import Text from "./Assets/Projects/text.png";


export const PROJECTS = [
  {
    image: Social,
    name: "Social Media App",
    technologyUsed: "ReactJs, Javascript, MongoDB, NodeJs, ExpressJs",
    description: "Created a fully featured and fully responsive MERN social media app with user authentication and authorization using bcrypt and JWT.",
    url: "https://github.com/CHINMAY02CS/SocialMediaApp",
  },
  {
    image: Ecommerce,
    name: "E-commerce Website",
    technologyUsed: "ReactJs, Redux, Bootstrap, Fake Store API",
    description: "Developed a fully responsive e-commerce site using frontend technologies.",
    url: "https://github.com/CHINMAY02CS/E-commerce-Website",
  },
  {
    image: Resume,
    name: "Resume Builder",
    technologyUsed: "ReactJs, Javascript, NodeJs",
    description: "Built and developed a personal portfolio website showcasing dedicated sections for Home, About, Portfolio, Experience, and Contact.",
    url: "https://github.com/CHINMAY02CS/Resume-Builder",
  },
  {
    image: Text,
    name: "TextUtils - React app",
    technologyUsed: "ReactJs, Javascript",
    description: "Created a Text processing react app where different actions on text can be taken to modify the text.",
    url: "https://github.com/CHINMAY02CS/TextUtil",
  },
  
];

export const SKILLS = [
  { name: "ReactJs", initialRating: 4 },
  { name: "JavaScript", initialRating: 4 },
  { name: "C++", initialRating: 4 },
  { name: "NodeJs", initialRating: 3 },
  { name: "ExpressJs", initialRating: 3 },
  { name: "Html", initialRating: 4 },
  { name: "CSS", initialRating: 4 },
  { name: "SQL", initialRating: 3 },
  { name: "MongoDB", initialRating: 3 },
  { name: "Github", initialRating: 4 },
  { name: "Python", initialRating: 4 },
  { name: "BootStrap", initialRating: 4 },
  { name: "Tailwind", initialRating: 4 },
  
];

export const TOOLS = ["Visual Studio Code", "Git", "Github", "Npm (Node Package Manager)", "ThunderClient", "Netlify", "PyCharm"]
